export default __webpack_public_path__ + "static/media/stockeer4.0073a318.png";